import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=cf3c50d4&scoped=true"
import script from "./Nav.vue.js?vue&type=script&lang=js&external"
export * from "./Nav.vue.js?vue&type=script&lang=js&external"
import style0 from "./Nav.vue?vue&type=style&index=0&id=cf3c50d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3c50d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCardText,VImg})
